module.exports = __webpack_public_path__ + "img/img-sportsbook2-d.96c58548.png";